module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="phx-lanceetat-detail cw-fieldset">\r\n    <div class="phx-formTable">\r\n        <div class="form-group phx-formErrors ui-state-error"></div>\r\n        <div class="phx-lanceetat-detail-content"></div>\r\n        <div class="unselectedElementText">\r\n            <label>'+
((__t=(i18n.t("lanceetat.unselectedElementText")))==null?'':__t)+
'</label>\r\n            <ul>\r\n                <li>\r\n                    <div class="textAccent1">\r\n                        '+
((__t=(i18n.t("lanceetat.imprimer")))==null?'':__t)+
' /\r\n                            '+
((__t=(i18n.t("lanceetat.exporter")))==null?'':__t)+
'\r\n                    </div>\r\n                    <span>'+
((__t=(i18n.t("lanceetat.text_selectionner")))==null?'':__t)+
'</span>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</fieldset>';
}
return __p;
};
